import React from 'react';
import DefaultContainer from '../../components/DefaultContainer';
import { Button, Text } from '~/components';
import CallCenterCard from '../../components/CallCenterCard';

import ChatSVG from '~/assets/svgs/chat.svg';
import PhoneSVG from '~/assets/svgs/phone.svg';

import { Linking } from 'react-native';
import { ASSURANT_WEBSITE } from '~/utils/url';
import { Components } from '~/scenes/HiredInsurance/components';
import useAppNavigation from '~/hooks/useAppNavigation';
import { useUserInfoStore } from '~/stores/userInfo';
import { useRoute, type RouteProp } from '@react-navigation/native';
import type { RootStackParamList } from '~/navigation/types';
import Footer from '../../components/Footer';

import AssurantLogoSVG from '~/assets/svgs/assurant-logo.svg';
import { callNumber } from '~/utils/device';

const HiredInsuranceCallCenterBagProtection: React.FC = () => {
  const { goBack } = useAppNavigation();

  const contractedServices = useUserInfoStore(
    (state) => state.user?.contractedServices
  );

  const {
    params: { id: certificateCode },
  } =
    useRoute<
      RouteProp<
        RootStackParamList,
        'MarisaServicos_HiredInsuranceCallCenterBagProtection'
      >
    >();

  const contractedService = contractedServices?.find(
    (service) => service.certificateCode === certificateCode
  );

  if (!contractedService) return null;

  return (
    <DefaultContainer type="bag-protection" className="py-[42px]">
      <Text className="text-lg text-gray-600">
        Central de Atendimento ao Segurado
      </Text>

      <CallCenterCard
        icon={ChatSVG}
        title="Acione via chat"
        subtitle={
          <Button
            variant="tertiary"
            className="mr-auto my-2 p-0"
            onPress={() => Linking.openURL(ASSURANT_WEBSITE)}
          >
            ACESSE AQUI
          </Button>
        }
        description="Você será redirecionado para o nosso parceiro, a Assurant Seguradora."
      />

      <CallCenterCard
        icon={PhoneSVG}
        title="Acione por telefone"
        description={
          <>
            <Text className="text-sm text-gray-400">
              Central de Atendimento (Abertura de Sinistro)
            </Text>
            <Button
              variant="tertiary"
              className="mr-auto my-2 p-0"
              onPress={() => callNumber('30030956')}
            >
              3003-0956
            </Button>
            <Text className="text-sm text-gray-400">
              Capitais e Regiões Metropolitanas
            </Text>
            <Button
              variant="tertiary"
              className="mr-auto my-2 p-0"
              onPress={() => callNumber('08006066302')}
            >
              0800-606-6302
            </Button>
            <Text className="text-sm text-gray-400">Demais Regiões</Text>
          </>
        }
      />

      <CallCenterCard
        icon={PhoneSVG}
        title="Acione por telefone"
        description={
          <>
            <Button
              variant="tertiary"
              className="mr-auto my-2 p-0"
              onPress={() => callNumber('08007779406')}
            >
              0800-777-9406
            </Button>
            <Text className="text-sm text-gray-400">
              Serviço de atendimento SAC
            </Text>
            <Button
              variant="tertiary"
              className="mr-auto my-2 p-0"
              onPress={() => callNumber('08007717266')}
            >
              0800-771-7266
            </Button>
            <Text className="text-sm text-gray-400">
              Deficiente auditivo/fala
            </Text>
          </>
        }
      />

      <Components.Divider />

      <Components.InsurancePolicyInfo
        policyNumber={contractedService.policyNumber}
        policyUrl={contractedService.policyUrl}
      />

      <Components.Divider />

      <Footer icon={AssurantLogoSVG} />

      <Button variant="tertiary" className="mt-[14px] w-full" onPress={goBack}>
        VOLTAR
      </Button>
    </DefaultContainer>
  );
};

export default HiredInsuranceCallCenterBagProtection;
